<template>
  <div class="l-image-list">
    <template v-for="(image,index) in fileObjects">

        <div class="l-image-wrap" :key="image.name" @click="openImage(index)">
            <img :src="image.url">
            <div>{{ image.name }}</div>
        </div>
    </template>
    <Modal v-model="showPreview" title="查看图片" :width="700" footer-hide :transfer="false">
        <img :src="current.url" style="width:100%" />
        <div style="position:absolute;z-index: 1000;left:50px;top:calc(50% - 25px);width:50px;background:#33333322;border-radius:50%;height:50px;display:flex;align-items:center;justify-content:center;cursor:pointer;" @click="prevBack" v-if="currentIndex!=0">
            <BaseIcon icon="ios-arrow-dropleft" :size="40" color="#fff" />
        </div>
        <div style="position:absolute;z-index: 1000;right:50px;top:calc(50% - 25px);width:50px;background:#33333322;border-radius:50%;height:50px;display:flex;align-items:center;justify-content:center;cursor:pointer;" @click="prevNext" v-if="currentIndex!=this.fileObjects.length - 1">
            <BaseIcon icon="ios-arrow-dropright" :size="40" color="#fff" />
        </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPreview: false,
      currentIndex: -1,
    };
  },
  props: ['files'],
  computed: {
    current() {
      return this.fileObjects[this.currentIndex] || {url: ''}; // 添加空对象保护
    },
    fileObjects() {
      if (!Array.isArray(this.files)) {
        return [];
      }
      return this.files.map((f, i)=>{
        if (typeof f == 'string') {
          let url = f;
          if (!f.startsWith('http')) {
            url = 'https://zzl.inbgz.com' + f;
          }
          return {
            name: '图片'+(i+1),
            url,
          };
        } else if (typeof f =='object') {
          return f;
        }
      }).filter((v)=>v);
    },
  },
  methods: {
    openImage(index) {
      this.currentIndex = index;
      this.showPreview =true;
    },
    prevBack() {
      if ( this.currentIndex == 0) {
        this.Error('前面没有了');
        return;
      }
      this.currentIndex = this.currentIndex-1;
    },
    prevNext() {
      if ( this.currentIndex == this.fileObjects.length - 1) {
        this.Error('已经最后一项了');
        return;
      }
      this.currentIndex = this.currentIndex + 1;
    },
  },
};
</script>

<style lang="less">
.l-image-list{
    display: flex;
    flex-wrap:wrap;

    .l-image-wrap{
        width:80px;
        height:120px;
        cursor: pointer;

        display: flex;
        flex-direction: column;
        align-items: center;
        margin:5px;
        overflow: hidden;
        img{
            width:100%;
            height:calc(100% - 20px);
            border-radius: 5px;
            border:1px solid var(--border);
        }
    }
}

</style>
